var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10930",
    "data-name": "Group 10930",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.483,
    height: 106,
    viewBox: "0 0 128.483 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3230",
    "data-name": "Rectangle 3230",
    width: 128.483,
    height: 106,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10929",
    "data-name": "Group 10929",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29437",
    "data-name": "Path 29437",
    d: "M337.51,76.211h9.076a2.761,2.761,0,0,1,2.76,2.76v4.517a2.76,2.76,0,0,1-2.76,2.76H337.51a2.759,2.759,0,0,1-2.76-2.76V78.971a2.76,2.76,0,0,1,2.76-2.76",
    transform: "translate(-222.746 -50.711)",
    fill: "#e4222e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29438",
    "data-name": "Path 29438",
    d: "M362.639,76.211h-3.764a2.761,2.761,0,0,1,2.76,2.76v4.517a2.76,2.76,0,0,1-2.76,2.76h3.764a2.76,2.76,0,0,0,2.76-2.76V78.971a2.761,2.761,0,0,0-2.76-2.76",
    transform: "translate(-238.799 -50.711)",
    fill: "#c0232c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29439",
    "data-name": "Path 29439",
    d: "M8.385,76.211h9.076a2.76,2.76,0,0,1,2.76,2.76v4.517a2.759,2.759,0,0,1-2.76,2.76H8.385a2.76,2.76,0,0,1-2.76-2.76V78.971a2.761,2.761,0,0,1,2.76-2.76",
    transform: "translate(-3.743 -50.711)",
    fill: "#e4222e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29440",
    "data-name": "Path 29440",
    d: "M289.5,261.016h17.566v13.4a3.389,3.389,0,0,1-3.389,3.389H292.889a3.389,3.389,0,0,1-3.389-3.389Z",
    transform: "translate(-192.636 -173.682)",
    fill: "#787681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29441",
    "data-name": "Path 29441",
    d: "M312.76,261.016v13.4a3.389,3.389,0,0,1-3.389,3.389H316.9a3.389,3.389,0,0,0,3.389-3.389v-13.4Z",
    transform: "translate(-205.858 -173.682)",
    fill: "#57565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29442",
    "data-name": "Path 29442",
    d: "M42,261.016H59.566v13.4a3.389,3.389,0,0,1-3.389,3.389H45.389A3.389,3.389,0,0,1,42,274.411Z",
    transform: "translate(-27.947 -173.682)",
    fill: "#787681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29443",
    "data-name": "Path 29443",
    d: "M65.26,261.016v13.4a3.389,3.389,0,0,1-3.389,3.389H69.4a3.389,3.389,0,0,0,3.389-3.389v-13.4Z",
    transform: "translate(-41.17 -173.682)",
    fill: "#57565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29444",
    "data-name": "Path 29444",
    d: "M33.514,76.211H29.75a2.76,2.76,0,0,1,2.76,2.76v4.517a2.759,2.759,0,0,1-2.76,2.76h3.764a2.759,2.759,0,0,0,2.76-2.76V78.971a2.76,2.76,0,0,0-2.76-2.76",
    transform: "translate(-19.796 -50.711)",
    fill: "#c0232c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29445",
    "data-name": "Path 29445",
    d: "M129.519,40.891l-8.213-21.354a7.527,7.527,0,0,0-7.026-4.827H51.633a7.529,7.529,0,0,0-7.026,4.825L36.393,40.891a17.468,17.468,0,0,1-3.552,5.669A17.481,17.481,0,0,0,28.125,58.5V89.994a7.528,7.528,0,0,0,7.528,7.528h94.606a7.528,7.528,0,0,0,7.528-7.528V58.5a17.481,17.481,0,0,0-4.716-11.943,17.468,17.468,0,0,1-3.552-5.669",
    transform: "translate(-18.715 -9.789)",
    fill: "#eb304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29446",
    "data-name": "Path 29446",
    d: "M289.437,46.56a17.467,17.467,0,0,1-3.552-5.669l-8.213-21.355a7.529,7.529,0,0,0-7.026-4.825h-7.528a7.529,7.529,0,0,1,7.026,4.825l8.213,21.355a17.467,17.467,0,0,0,3.552,5.669A17.481,17.481,0,0,1,286.625,58.5V89.994a7.528,7.528,0,0,1-7.528,7.528h7.528a7.528,7.528,0,0,0,7.528-7.528V58.5a17.481,17.481,0,0,0-4.716-11.943",
    transform: "translate(-175.08 -9.789)",
    fill: "#e4222e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29447",
    "data-name": "Path 29447",
    d: "M158.378,242.748H91.125l8.392-7.273a10.288,10.288,0,0,1,6.738-2.513h36.993a10.288,10.288,0,0,1,6.738,2.513Z",
    transform: "translate(-60.635 -155.014)",
    fill: "#57565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29448",
    "data-name": "Path 29448",
    d: "M231.186,235.474a10.288,10.288,0,0,0-6.738-2.513H213.156a10.288,10.288,0,0,1,6.738,2.513l8.392,7.273h11.292Z",
    transform: "translate(-141.836 -155.014)",
    fill: "#3c3b41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29449",
    "data-name": "Path 29449",
    d: "M159.664,179.751H121.077a2,2,0,0,1-1.632-.84l-4.661-6.525a2.008,2.008,0,0,1,1.634-3.175h47.907a2.008,2.008,0,0,1,1.634,3.175L161.3,178.91a2,2,0,0,1-1.632.84",
    transform: "translate(-76.129 -112.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29450",
    "data-name": "Path 29450",
    d: "M231.866,169.211H220.574a2.008,2.008,0,0,1,1.634,3.175l-4.661,6.525a2,2,0,0,1-1.632.84h11.292a2,2,0,0,0,1.632-.84l4.661-6.525a2.008,2.008,0,0,0-1.634-3.175",
    transform: "translate(-143.671 -112.595)",
    fill: "#e1e1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29451",
    "data-name": "Path 29451",
    d: "M310.167,174.857a5.646,5.646,0,1,1-5.646-5.646,5.646,5.646,0,0,1,5.646,5.646",
    transform: "translate(-198.874 -112.595)",
    fill: "#fddd5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29452",
    "data-name": "Path 29452",
    d: "M312.007,169.211a5.622,5.622,0,0,0-1.882.323,5.647,5.647,0,0,1,0,10.648,5.647,5.647,0,1,0,1.882-10.971",
    transform: "translate(-206.36 -112.595)",
    fill: "#fed030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29453",
    "data-name": "Path 29453",
    d: "M62.667,174.857a5.646,5.646,0,1,1-5.646-5.646,5.646,5.646,0,0,1,5.646,5.646",
    transform: "translate(-34.185 -112.595)",
    fill: "#fddd5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29454",
    "data-name": "Path 29454",
    d: "M64.507,169.211a5.622,5.622,0,0,0-1.882.323,5.647,5.647,0,0,1,0,10.648,5.647,5.647,0,1,0,1.882-10.971",
    transform: "translate(-41.671 -112.595)",
    fill: "#fed030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29455",
    "data-name": "Path 29455",
    d: "M80.914,38.063h60.234a1.507,1.507,0,0,1,1.4.963l9.09,23.483a1.506,1.506,0,0,1-1.4,2.049H71.823a1.506,1.506,0,0,1-1.4-2.049l9.09-23.483a1.507,1.507,0,0,1,1.4-.963",
    transform: "translate(-46.79 -25.327)",
    fill: "#52bbe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29456",
    "data-name": "Path 29456",
    d: "M277.535,62.509l-9.09-23.483a1.507,1.507,0,0,0-1.4-.963h-7.528a1.507,1.507,0,0,1,1.4.963l9.09,23.483a1.506,1.506,0,0,1-1.4,2.049h7.528a1.506,1.506,0,0,0,1.4-2.049",
    transform: "translate(-172.682 -25.327)",
    fill: "#1cabe1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterCarIcon);
export default __webpack_public_path__ + "static/media/enter_car_icon.8ee9d4174474be8f9a2357314f5316a7.svg";
export { ForwardRef as ReactComponent };